import { BaseOperation } from 'application/editor/operations/BaseOperation';
import { OperationType } from 'application/editor/operations/OperationType';
import type { MonomerCreationState, ReStruct } from 'application/render';
import assert from 'assert';
import type { AttachmentPointName } from 'domain/types';

export class ReassignLeavingAtomOperation extends BaseOperation {
  constructor(
    private monomerCreationState: MonomerCreationState,
    private readonly attachmentPointName: AttachmentPointName,
    private readonly attachmentAtomId: number,
    private readonly newLeavingAtomId: number,
    private readonly previousLeavingAtomId: number,
  ) {
    super(OperationType.MONOMER_CREATION_REASSIGN_LGA);
  }

  execute(restruct: ReStruct) {
    assert(this.monomerCreationState);

    const newAtomPair: [number, number] = [
      this.attachmentAtomId,
      this.newLeavingAtomId,
    ];

    this.monomerCreationState.assignedAttachmentPoints.set(
      this.attachmentPointName,
      newAtomPair,
    );

    this.monomerCreationState = { ...(this.monomerCreationState || {}) };

    BaseOperation.invalidateAtom(restruct, this.attachmentAtomId);
    BaseOperation.invalidateAtom(restruct, this.newLeavingAtomId);
    BaseOperation.invalidateAtom(restruct, this.previousLeavingAtomId);
  }

  invert(): BaseOperation {
    return new ReassignLeavingAtomOperation(
      this.monomerCreationState,
      this.attachmentPointName,
      this.attachmentAtomId,
      this.previousLeavingAtomId,
      this.newLeavingAtomId,
    );
  }
}
